<template>
    <div
        class="relative pt-6 pb-12 text-center sm:pb-16 md:pb-20 lg:pb-28 xl:pb-32"
    >
        <Header />

        <div class="flex flex-col items-center justify-center ">
            <h1 class="pt-4 mt-4 text-3xl font-bold text-blue-600 ">
                Chose un Business Plan
            </h1>

            <div
                class="w-1/4 h-3 mb-6 -mt-2 border-b-4 border-blue-600 rounded "
            ></div>
        </div>
        <div class="flex justify-center ">
            <ul class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                <li class="col-span-1 bg-white rounded-lg shadow">
                    <div
                        class="flex items-center justify-between w-full p-6 space-x-6"
                    >
                        <div class="flex-1 truncate">
                            <div class="flex items-center space-x-3">
                                <h3
                                    class="text-sm font-medium leading-5 text-gray-900 truncate"
                                >
                                    bpi
                                </h3>
                                <span
                                    class="flex-shrink-0 inline-block px-2 py-0.5 text-teal-800 text-xs leading-4 font-medium bg-teal-100 rounded-full"
                                    >Admin</span
                                >
                            </div>
                            <p
                                class="mt-1 text-sm leading-5 text-gray-500 truncate"
                            >
                                Business Plan
                            </p>
                        </div>
                        <svg
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            class="w-6 h-6 document"
                        >
                            <path
                                fill-rule="evenodd"
                                d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z"
                                clip-rule="evenodd"
                            ></path>
                        </svg>
                    </div>
                </li>
            </ul>
        </div></div
></template>

<script>
import Header from "../components/header";
export default {
    components: {
        Header
    },
    data() {
        return {};
    },
    methods: {}
};
</script>

<style></style>
